import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL, profile_img } from "../../Service";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [profileImg, setProfileImg] = useState("");
  const [salesHeadName, setSalesHeadName] = useState("");
  const [userType, setUserType] = useState("");
  console.log(location.pathname.slice(1)); // Log the sliced pathname
  const user_id = sessionStorage.getItem("user_id");
  const [notificationscount, setNotificationscount] = useState(0);
  const [notificationscount1, setNotificationscount1] = useState(0);
  const [notificationscount2, setNotificationscount2] = useState(0);
  const [notificationscount3, setNotificationscount3] = useState(0);

  const handleNavigation = () => {
    const userType = sessionStorage.getItem("userType");
    console.log(userType)
    switch (userType) {
      case "SalesHead":
        navigate("profile");
        break;
      case "MarketingHead":
        navigate("MProfile");
        break;
      case "ClinicalTeam":
        navigate("CProfile");
        break;
      case "FinanceHead":
        navigate("FProfile");
        break;
      default:
        console.error("Unknown user type");
        break;
    }
  };


  
  const handleNotificationNavigation = () => {
    const userType = sessionStorage.getItem("userType");
    switch (userType) {
      case "SalesHead":
        navigate("NotificationSales");
        break;
      case "MarketingHead":
        navigate("NotificationMarketing");
        break;
      case "ClinicalTeam":
        navigate("NotificationClinical");
        break;
      case "FinanceHead":
        navigate("NotificationFinance");
        break;
      default:
        console.error("Unknown user type");
        break;
    }
  };
  useEffect(() => {
    getProfile();
   const userType = sessionStorage.getItem("userType");
  
    // Call appropriate notification function based on userType
    if (userType === "ClinicalTeam") {
      GetNotificationClinical();
    } else if (userType === "FinanceHead") {
      GetNotificationFinance();
    } else if (userType === "MarketingHead") {
      GetNotificationMarketing();  // Call the NotificationMarketing function
    } else if (userType === "SalesHead") {
      GetNotificationSales();  // Call the NotificationSales function
    }
  }, []);
  
  
  
  const GetNotificationClinical =()=> {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    
    const raw = JSON.stringify({
      "ch_id": user_id
    });
    
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };
    
    fetch(API_URL+'getCHNotifications', requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        if (result.status && typeof result.unreadCount === 'number') {
          setNotificationscount(result.unreadCount);
        } else {
          setNotificationscount(); // Fallback in case unreadCount is missing
        }
      })
      .catch((error) => {
        console.error(error);
        setNotificationscount(0); // Fallback on error
      });
  }

    const GetNotificationFinance = () => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
  
      const raw = JSON.stringify({
        "fh_id": user_id
      });
  
      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };
  
      fetch(API_URL + 'getFHNotifications', requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          if (result.status && typeof result.unreadCount === 'number') {
            setNotificationscount(result.unreadCount);
          } else {
            setNotificationscount1(); // Fallback in case unreadCount is missing
          }
        })
        .catch((error) => console.error(error));
    }

      const GetNotificationMarketing =()=> {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        
        const raw = JSON.stringify({
          "mh_id": user_id
        });
        
        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow"
        };
        
        fetch(API_URL+'getMHNotifications', requestOptions)
          .then((response) => response.json())
          .then((result) => {
            console.log(result);
            if (result.status && typeof result.unreadCount === 'number') {
              setNotificationscount2(result.unreadCount);
            } else {
              setNotificationscount2(); // Fallback in case unreadCount is missing
            }
          })
           .catch((error) => console.error(error));
      }

       const GetNotificationSales =()=> {
          const myHeaders = new Headers();
          myHeaders.append("Content-Type", "application/json");
          
          const raw = JSON.stringify({
            "sh_id": user_id
          });
          
          const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow"
          };
          
          fetch(API_URL+'getSHNotifications', requestOptions)
            .then((response) => response.json())
            .then((result) => {
              console.log(result);
              if (result.status && typeof result.unreadCount === 'number') {
                setNotificationscount3(result.unreadCount);
              } else {
                setNotificationscount3(); // Fallback in case unreadCount is missing
              }
            })     .catch((error) => console.error(error));
        }
  console.log('Notifications count:', notificationscount);

  const getProfile = () => {
    const userType = sessionStorage.getItem("userType");

    const endpoint =
    userType === "SalesHead"
        ? "getByIdSales"
        : userType === "MarketingHead"
        ? "getByIdMH"
        : userType === "ClinicalTeam"
        ? "getByIdClinical"
        : userType === "FinanceHead"
        ? "getByIdFinanceHead"
        : null;
    const user_id = sessionStorage.getItem("user_id");
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      userId: user_id,
    });

    console.log(user_id);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + endpoint, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == true) {
          console.log('getProfile',result);
          setProfileImg(result?.user?.profile_img);
          setSalesHeadName(result?.user?.name);
          setUserType(result?.user?.userType); // Save the userType to state

        } else {
          console.log(result);
        }
      })
      .catch((error) => console.error(error));
  };

  const Logout = () => {
    sessionStorage.clear();
    navigate("/");
  };
  return (
    <div className="Navbar">
      <div className="Navbar-sub">
      <div className="Navbar-title1">
       <div className="Navbar-title">
          {/* {location.pathname.slice(1)} */}
          <span className="title-text">
  {["NotificationSales", "NotificationMarketing", "NotificationClinical", "NotificationFinance"].includes(location.pathname.slice(1))
    ? "Notification"
    : location.pathname.slice(1) === "MarketingAnalytics"
    ? "Analytics"
    : location.pathname.slice(1) === "FinanceManagement"
    ? "Finance Management"
    : location.pathname.slice(1) === "InventoryManagement"
    ? "Inventory Management"
    : location.pathname.slice(1) === "PurchaseOrder"
    ? "Purchase Order"
    : location.pathname.slice(1) === "HelpSupport"
    ? "Help & Support"
    : location.pathname.slice(1) === "KPIManagement"
    ? "KPI Management"
    : location.pathname.slice(1) === "MyDashboard"
    ? "My Dashboard"
    : location.pathname.slice(1) === "Event"
    ? "Event"
    : location.pathname.slice(1) === "Sales"
    ? "Primary Sales"
    : location.pathname.slice(1) === "SInventory"
    ? "Inventory Management"
    : location.pathname.slice(1) === "profile" || location.pathname.slice(1) === "MProfile" || location.pathname.slice(1) === "CProfile" || location.pathname.slice(1) === "FProfile"
    ? "My Profile"
    : location.pathname.slice(1) === "Help"
    ? "Chat"
    : location.pathname.slice(1)}
</span>




          </div>
          
          <div className="Navbar-title2">
          <span>
  {["Analytics", "MarketingAnalytics", "KPIManagement", "Event", "MyDashboard", "FinanceManagement", "InventoryManagement"].includes(location.pathname.slice(1))
    ? location.pathname.slice(1) === "FinanceManagement" || location.pathname.slice(1) === "InventoryManagement"
      ? "View different types of data related to finance"
      : "View different types of data related to sales"
    : location.pathname.slice(1) === "Sales" || location.pathname.slice(1) === "Scheme"
    ? "Modify / update the sale based on the inputs received from stockiest / TBM’s."
    : location.pathname.slice(1) === "SInventory"
    ? "Data related to inventory can be viewed in this section"
    : location.pathname.slice(1) === "HelpSupport"
    ? "Get help from admin through email for queries"
    : location.pathname.slice(1) === "Help"
    ? "Users can engage in live conversations"
    : location.pathname.slice(1) === "profile" || location.pathname.slice(1) === "MProfile" || location.pathname.slice(1) === "CProfile" || location.pathname.slice(1) === "FProfile"
    ? "View profile detail settings"
    : location.pathname.slice(1) === "PurchaseOrder"
    ? "Feeding primary sales to the system"
    : ""}
</span>
</div>
 </div>
      

        <div className="Navbar-profileItems">
          <div className="Navbar-profile-wrapper">
          <div className="Navbar-profile-text">
              <span>{salesHeadName}</span>
              <span>{userType}</span> {/* Display the userType dynamically */}
            </div>
            <div className="">
              {profileImg === "" ? (
                <img
                  src={require("../../Assets/Profilepic.png")}
                  width={44}
                  height={44}
                  alt=""
                  style={{ cursor: "pointer" }}
                  onClick={handleNavigation}
                />
              ) : (
                <img
                  src={profile_img + profileImg}
                  alt=""
                  style={{
                    objectFit: "cover",
                    borderRadius: "50%",
                    width: "50px",
                    height: "50px",
                    cursor: "pointer",
                  }}
                  onClick={handleNavigation}
                />
              )}
            </div>

         
            <div className="Navbar-notification">
  {notificationscount > 0 && (
    <span className="notification-count">{notificationscount}</span>
  )}
  {notificationscount1 > 0 && (
    <span className="notification-count">{notificationscount1}</span>
  )}
  {notificationscount2 > 0 && (
    <span className="notification-count">{notificationscount2}</span>
  )}
  {notificationscount3 > 0 && (
    <span className="notification-count">{notificationscount3}</span>
  )}
  <img
    src={require("../../Assets/notifications.png")}
    width={24}
    height={24}
    style={{ cursor: "pointer" }}
    alt="Notifications"
    onClick={handleNotificationNavigation}
  />
</div>



            <div className="Navbar-logout">
              <img
                src={require("../../Assets/logout.png")}
                width={32}
                height={32}
                style={{ cursor: "pointer" }}
                alt=""
                onClick={() => Logout()}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
